import assert from 'minimalistic-assert';
const createApi = ({ ioc, port, }) => {
    const apis = ioc.getByType('api');
    const featureApis = Object.create(null);
    for (const api of Object.values(apis)) {
        for (const [namespace, methods] of Object.entries(api)) {
            if (!(namespace in featureApis)) {
                featureApis[namespace] = methods;
                continue;
            }
            for (const [method, implementation] of Object.entries(methods)) {
                assert(!(method in featureApis[namespace]), `duplicate definition of API method "${method}" in "${namespace}"`);
                featureApis[namespace][method] = implementation;
            }
        }
    }
    return {
        ...featureApis,
        subscribe: port.subscribe.bind(port),
        unsubscribe: port.unsubscribe.bind(port),
    };
};
export default createApi;
